import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireScreenAnalytics, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { sendPendoTrackEvent } from './sendPendoTrackEvent.tsx';

export const TreeView = {
	opened: (event: UIAnalyticsEvent, accessLevel?: string): void => {
		sendPendoTrackEvent({
			actionSubjectAndAction: 'treeView opened',
			attributes: { accessLevel: accessLevel || '' },
		});
		fireScreenAnalytics(event, { accessLevel });
	},
	treeDirectionChanged: (event: UIAnalyticsEvent, direction?: string): void => {
		sendPendoTrackEvent({
			actionSubjectAndAction: 'treeDirection changed',
			attributes: { direction: direction || '' },
		});
		fireTrackAnalytics(event, 'treeDirection changed', {
			direction: direction || '',
		});
	},
	connectionRemoved: (event: UIAnalyticsEvent): void => {
		sendPendoTrackEvent({
			actionSubjectAndAction: 'treeConnection removed',
			attributes: {},
		});
		fireTrackAnalytics(event, 'treeConnection removed');
	},
	nodeReordered: (
		event: UIAnalyticsEvent,
		parentChangeType: 'idea-idea' | 'field-field' | 'none',
	): void => {
		sendPendoTrackEvent({
			actionSubjectAndAction: 'treeNode reordered',
			attributes: {
				parentChangeType,
			},
		});
		fireTrackAnalytics(event, 'treeNode reordered', { parentChangeType: parentChangeType || '' });
	},
};
